export default __webpack_public_path__ + "static/media/SinglePointofAccess-South-SheffieldDirecttospecialitiesNGH.67c0a735.jpg";